export const searchModalLabels = {
    confirmLabel: "Apply",
    cancelLabel: "Cancel",
    tooltipTextStandard:
        'Displays results that contain terms starting with the entered search criteria. For example, enter "bow" to locate matches with the terms "bow" or "bowtie."',
    tooltipTextEnhanced:
        'Displays results that contain terms appearing in any part of the entered search criteria. For example, enter "tie" to locate matches with the terms "tie" or "bowtie."',
    radioButtonName: "search-type",
    searchTypeModalId: "expanded-search-type-popup",
    informationText: "Learn more about",
};

export const searchModalLinks = {
    productSearchLink:
        "https://helpdesk.nuorder.com/hc/en-us/articles/201010833-How-to-find-products-in-the-All-Products-gallery-for-Buyers-#h_01FTGSPP34PZCXEZKR2RY38YQV",
};

export enum SearchTypes {
    Standard = "Standard",
    Expanded = "Expanded (slower)",
    StandardValue = "standard",
    ExpandedValue = "expanded",
}
